import { Controller } from '@hotwired/stimulus'

import { loadDeviceKeyFromSessionOnce, redirectIfEncryptionLocked } from '../encryption/encryption'

// Connects to data-controller="prepare-encryption"
// Loads device keys from session to make sure that encryption/decryption works properly.
// If keys are not available, redirects the user to the unlocking form
export default class extends Controller {
  static targets = ['skeleton', 'content', 'loading']
  static values = { isLocalAccount: Boolean }

  async connect() {
    await loadDeviceKeyFromSessionOnce()
    // In case the user is redirected, do not modify the DOM to prevent sudden changes on the page - that is important especially on mobile apps.
    // The redirect is not preventing the further execution of the code!
    if (!redirectIfEncryptionLocked()) {
      // On the initial app boot on mobile apps, the redirect is very abrupt. To make it easier for the user to understand what is happening, we show a full-page loading indicator.
      if (this.hasLoadingTarget) {
        this.loadingTarget.classList.add('hidden')
      }
      this.skeletonTarget.classList.add('hidden')
      this.contentTarget.classList.remove('hidden')

      window.dispatchEvent(new Event('resize'))
    }
  }

  declare isLocalAccountValue: boolean
  declare skeletonTarget: HTMLElement
  declare contentTarget: HTMLElement
  declare loadingTarget: HTMLElement
  declare hasLoadingTarget: boolean
}
